(function () {
  // Use the `data-video-banner` attribute to identify the video banner element
  var videoBanner = document.querySelector("[data-video-banner]");
  if (!videoBanner) return;

  //helper function to avoid repeating the same DOM query
  function hideFallbackImages(context, breakpoint) {
    var fallbackImages = context.querySelectorAll(
      "img.vb-fallback.vb-" + breakpoint,
    );
    //Explicit check before iterating
    if (!fallbackImages.length) return;

    fallbackImages.forEach(function (img) {
      img.style.opacity = "0";
    });
  }

  //helper function to determine the breakpoint based on the closest wrapper class dekstop or mobile
  function getBreakpoint(mediaEl) {
    var wrapper = mediaEl.closest(".vb-dk, .vb-mb");
    if (!wrapper) return null;
    return wrapper.classList.contains("vb-dk") ? "dk" : "mb";
  }

  //check before attaching video listeners
  var videos = videoBanner.querySelectorAll("video");
  if (videos.length) {
    videos.forEach(function (video) {
      video.addEventListener("playing", function () {
        var breakpoint = getBreakpoint(video);
        if (!breakpoint) return;
        hideFallbackImages(videoBanner, breakpoint);
      });
    });
  }

  //check before attaching iframe listeners
  var iframes = videoBanner.querySelectorAll("iframe");
  if (iframes.length) {
    iframes.forEach(function (iframe) {
      iframe.addEventListener("load", function () {
        var breakpoint = getBreakpoint(iframe);
        if (!breakpoint) return;
        hideFallbackImages(videoBanner, breakpoint);
      });
    });
  }
})();
